export default () => Math.round(new Date().getTime() / 1000);